const styles = ':host{color:inherit;display:flex;font-weight:700}skapa-icon{flex-shrink:0}:host([no-bullet]) skapa-icon{display:none}slot{display:block;font-size:.75rem;line-height:1.5;padding-bottom:.1875rem;padding-top:.1875rem}:host([emphasised]){color:var(--skapa-offer-message-emphasised-colour,inherit)}';
import { Icon } from "@ingka/icon-webc/passive.js";
import SkapaElement from "@ingka/skapa-webc-element";
import { bullet } from "@ingka/icon-store";
function getTemplates({ html }) {
  const template = document.createElement("template");
  template.innerHTML = html`
    <style>
      ${styles}
    </style>
    <skapa-icon slot="icon" icon="bullet"></skapa-icon>
    <slot></slot>
  `;
  return { main: template };
}
class OfferMessage extends SkapaElement {
  constructor() {
    super();
    const shadow = this.attachShadow({ mode: "open" });
    const { main } = this.getTemplates(getTemplates);
    shadow.append(main.content.cloneNode(true));
  }
  get noBullet() {
    return this.hasAttribute("no-bullet");
  }
  set noBullet(value) {
    this.toggleAttribute("no-bullet", !!value);
  }
}
OfferMessage.skapaTagName = "offer-message";
OfferMessage.skapaDependencies = [Icon];
OfferMessage.skapaIconDependencies = [bullet];
OfferMessage.observedAttributes = [];
export {
  OfferMessage
};
